"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inbox = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const inbox = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'inbox-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10 3C10.4142 3 10.75 3.33579 10.75 3.75L10.75 7.06967V11.3893L12.4697 9.66967C12.7626 9.37678 13.2374 9.37678 13.5303 9.66967C13.8232 9.96256 13.8232 10.4374 13.5303 10.7303L10 14.2607L6.46967 10.7303C6.17678 10.4374 6.17678 9.96256 6.46967 9.66967C6.76256 9.37678 7.23744 9.37678 7.53033 9.66967L9.25 11.3893L9.25 3.75C9.25 3.33579 9.58579 3 10 3ZM3 11C3.41421 11 3.75 11.3358 3.75 11.75V16H16.25V11.75C16.25 11.3358 16.5858 11 17 11C17.4142 11 17.75 11.3358 17.75 11.75V16.75C17.75 17.1643 17.4142 17.5 17 17.5H3C2.58579 17.5 2.25 17.1643 2.25 16.75V11.75C2.25 11.3358 2.58579 11 3 11Z', fill: '#4B5563' })));
};
exports.inbox = inbox;
